import { render, staticRenderFns } from "./TextCopiedToaster.vue?vue&type=template&id=77cef061&scoped=true"
import script from "./TextCopiedToaster.vue?vue&type=script&lang=js"
export * from "./TextCopiedToaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cef061",
  null
  
)

export default component.exports